module.exports = __webpack_public_path__ + "img/logo-innovare-small.54465f63.png";